import createTheme from '@mui/material/styles/createTheme'

import { HistoryLink } from 'lib/Link'

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: false // removes the `xs` breakpoint
    sm: false
    md: false
    lg: false
    xl: true
    mobile: true // adds the `mobile` breakpoint
    tablet: true
    laptop: true
    desktop: true
  }
}

declare module '@mui/material/styles/createPalette' {
  interface TypeText {
    light?: string
  }
}

let tempTheme: ReturnType<typeof createTheme> | null = createTheme({
  palette: {
    contrastThreshold: 3,
    tonalOffset: 0.4,
  },
})

export const theme = createTheme({
  breakpoints: {
    values: {
      laptop: 1080,
      tablet: 768,
      mobile: 0,
      desktop: 1280,
      xl: 1500,
    },
  },
  palette: {
    mode: 'light',
    background: {
      default: '#fefff8',
      paper: '#fefff8',
    },
    primary: {
      main: 'rgb(99, 74, 255)',
      // main: 'rgb(52 171 148)',
      light: '#7a73ff',
      dark: '#7a73ff',
      contrastText: '#fff',
    },
    secondary: {
      main: 'rgb(52, 171, 148)',
      light: 'rgb(52, 171, 148)',
      dark: 'rgb(52, 171, 148)',
      contrastText: '#fff',
    },
    text: {
      primary: '#393e48',
      secondary: '#596171',
      light: '#a4b3d3',
    },
    success: tempTheme.palette.augmentColor({
      color: {
        main: '#d1fab3',
      },
      name: 'success',
    }),
  },
  typography: {
    fontFamily: [
      "'Inter'",
      "'Bebas Neue'",
      '"Roboto Condensed"',
      'arial',
      'sans-serif',
      'system',
    ].join(', '),
    h4: {
      fontWeight: '700',
    },
    h5: {
      fontWeight: '700',
    },
    h6: {
      fontWeight: '700',
    },
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiUseMediaQuery: {
      defaultProps: {
        // defaultMatches: true,
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        fontWeight: 800,
        fontSmooth: 'always',
        fill: '#675dff',
        height: '100vh',
      },
    },
    MuiLink: {
      defaultProps: {
        component: HistoryLink,
      },
    },
    MuiButtonBase: {
      defaultProps: {
        LinkComponent: HistoryLink,
      },
    },
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.variant === 'contained' && {
            boxShadow: 'none',
            border: '1px solid',
            ':hover': {
              boxShadow: 'none',
            },
          }),
        }),
      },
    },
    MuiIconButton: {
      defaultProps: {
        LinkComponent: HistoryLink,
      },
    },
    MuiChip: {
      defaultProps: {
        sx(_theme) {
          return {
            borderRadius: 1,
          }
        },
      },
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.color === 'success' &&
            ownerState.variant === 'filled' && {
              borderColor: theme.palette.success.dark,
              color: theme.palette.success.dark,
              borderWidth: 1,
              borderStyle: 'solid',
            }),
        }),
      },
    },
  },
})

tempTheme = null
